import { Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import SermonList from "./components/pages/SermonList";
import SermonDetail from "./components/pages/SermonDetail";
import Editor from "./components/organisms/Editor";
import ColumnList from "./components/pages/ColumnList";
import ColumnDetail from "./components/pages/ColumnDetail";
import ColumnEditor from "./components/organisms/ColumnEditor";
import ScrollToTop from "./components/ScrollToTop";

const Router = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sermons" element={<SermonList />} />
        <Route path="/sermon/new" element={<Editor />} />
        <Route path="/sermon/edit/:id" element={<Editor />} />
        <Route path="/sermon/:id" element={<SermonDetail />} />
        <Route path="/columns" element={<ColumnList />} />
        <Route path="/column/new" element={<ColumnEditor />} />
        <Route path="/column/edit/:id" element={<ColumnEditor />} />
        <Route path="/column/:id" element={<ColumnDetail />} />
      </Routes>
    </>
  );
};

export default Router;
